export const api_booking = {
  addNewBooking: (userId) => ({api: `/api/v2/medCenters/${userId}/booking`, method: "POST"}),

}